import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import styles from './ThankYou.module.css';
import { DesktopView } from './desktop/YourChildAge.desktop';
import { MobileView } from './mobile/YourChildAge.mobile';

export const YourChildAge = (): JSX.Element => {
  // Redux Hooks

  return (
    <React.Fragment>
      {isMobileOnly ? <MobileView /> : <DesktopView />}
    </React.Fragment>
  );
};
